import React from "react";
import { Wrapper } from "./style";
import Com1 from "./components/Com1";
import Com2 from "./components/Com2";
import Com3 from "./components/Com3";
import DesignCom from "./components/DesignCom";
import { useQuery } from "react-query";
import { axiosInstance } from "api";
import Loading from "components/Loading";
const CommunityHome = () => {
  const {
    isSuccess: socialSuccess,
    data: socialLinkData,
    isLoading: socialLoading,
  } = useQuery("socialLink", () => axiosInstance.get("/link/social"));

  const {
    isSuccess: techSuccess,
    data: techLinkData,
    isLoading: techLoading,
  } = useQuery("techLink", () => axiosInstance.get("/link/tech"));

  if (socialLoading || techLoading) return <Loading />;

  return (
    <>
      {socialSuccess && techSuccess && (
        <Wrapper>
          <Com1 />
          <Com2 socialLinkData={socialLinkData.data} />
          <Com3 techLinkData={techLinkData.data} />
          <DesignCom />
        </Wrapper>
      )}
    </>
  );
};

export default CommunityHome;
